"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Product = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NavMenuItem = _interopRequireDefault(require("../../NavMenuItem"));

var _ProductCrossActivationStatus = require("./ProductCrossActivationStatus");

var _ProductTexts = require("./ProductTexts");

var _productsStatus = require("../productsStatus");

var Product = function Product(props) {
  var description = props.description,
      features = props.features,
      id = props.id,
      onLinkClick = props.onLinkClick,
      productStatus = props.productStatus,
      title = props.title,
      url = props.url,
      inverted = props.inverted,
      swicusOrgId = props.swicusOrgId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-switcher-product"
  }, productStatus === _productsStatus.PRODUCT_STATUS.CURRENT_PRODUCT ? /*#__PURE__*/_react["default"].createElement("div", {
    "data-qa": "app-switcher-".concat(id),
    className: (0, _classnames["default"])('cloud-ui-nav-menu-link', 'cloud-ui-nav-menu-current-product')
  }, /*#__PURE__*/_react["default"].createElement(ProductContent, {
    swicusOrgId: swicusOrgId,
    title: title,
    description: description,
    productStatus: productStatus,
    features: features,
    inverted: inverted
  })) : /*#__PURE__*/_react["default"].createElement(_NavMenuItem["default"], {
    "data-qa": "app-switcher-".concat(id),
    href: url,
    newTab: true,
    onClick: onLinkClick
  }, /*#__PURE__*/_react["default"].createElement(ProductContent, {
    title: title,
    description: description,
    productStatus: productStatus,
    features: features,
    inverted: inverted,
    swicusOrgId: swicusOrgId
  })));
};

exports.Product = Product;

var ProductContent = function ProductContent(_ref) {
  var title = _ref.title,
      description = _ref.description,
      productStatus = _ref.productStatus,
      features = _ref.features,
      inverted = _ref.inverted,
      swicusOrgId = _ref.swicusOrgId;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ProductTexts.ProductTexts, {
    title: title,
    description: description,
    status: productStatus
  }), /*#__PURE__*/_react["default"].createElement(_ProductCrossActivationStatus.ProductCrossActivationStatus, {
    status: productStatus,
    features: features,
    inverted: inverted,
    swicusOrgId: swicusOrgId
  }));
};

var _default = Product;
exports["default"] = _default;